import 'dayjs/locale/en';
import 'dayjs/locale/he';

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import {BehaviorSubject, Observable} from 'rxjs';

import {inject, NgZone, OnDestroy, Pipe, PipeTransform} from '@angular/core';
import {LanguageService} from '@core/language';

// Extend dayjs with plugins
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);

@Pipe({
	name: 'TimePipe',
	standalone: true,
})
export class TimePipe implements PipeTransform, OnDestroy {
	private interval: any | null = null;
	private time$: BehaviorSubject<string> = new BehaviorSubject('');
	private languageService: LanguageService = inject(LanguageService);
	private ngZone: NgZone = inject(NgZone);

	constructor() {
		if (this.languageService.currentLang$() == 'he') {
			dayjs.locale('he');
		} else {
			dayjs.locale('en');
		}
	}

	transform(timestamp: Date | string, timezone: string = dayjs.tz.guess()): Observable<string> {
		if (!timestamp) {
			this.time$.next('');
			return this.time$.asObservable();
		}

		const utcDate = dayjs.utc(timestamp);

		utcDate.tz(timezone);

		const updateTime = () => {
			// Calculate relative time using utc date
			const relativeTime = utcDate.fromNow();

			this.time$.next(relativeTime);
		};

		updateTime();

		// Clear any existing interval to prevent memory leaks
		if (this.interval) {
			clearInterval(this.interval);
		}

		// Update the time string every second within Angular's zone to ensure change detection
		this.ngZone.run(() => {
			this.interval = setInterval(updateTime, 1000);
		});

		return this.time$.asObservable();
	}

	ngOnDestroy(): void {
		if (this.interval) {
			clearInterval(this.interval);
		}
	}
}
